export default function (dependencies) {
  return {
    imports: dependencies.reduce((acc, curr) => {
      const { name, url } = curr
      return { ...acc, [`@platform/${name}`]: url }
    }, {}),
  }
}
